// 页面数据通信用
import Vue from 'vue';
var bus = new Vue({});
export default bus;